<template>
	<div class="top ">
		<div class="head">
			<div class="wd-container">
				<el-row type="flex" justify="space-between">
					<el-col :span="12">
						<el-row type="flex" justify="start">
							<el-col :span="12">
								<div class="selectaddrcss wd-flex wd-row-between">
									<div class="wd-row-noshrink">送货至：</div>
									<el-cascader ref="addr" v-model="logininfo.addrinfo" :options="options" style="width: 100%;" placeholder="请选择所在地区" @change="handleChange" />
								</div>
							</el-col>
							<el-col>
								<el-link type="primary" :underline="false" @click="handleSelect('Myinfo')">{{ logininfo.myinfo.name }} {{ logininfo.myinfo.mobile }}</el-link>
								<span class="wd-m-l-10">|</span>
								<el-link class="wd-m-l-10" :underline="false" @click="handleSelect('loginout')">退出登录</el-link>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="12">
						<el-row type="flex" justify="end" class="top_r">
							<div class="a wd-cursor" @click="handleSelect('Orderlist')">我的订单</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Historylist')">我的浏览</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Favlist')">我的收藏</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Help')">帮助中心</div>
							<div class="b"></div>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="memtop" v-if="showtop === 0">
			<div class="wd-container  wd-flex wd-row-between">
				<div class="logo wd-cursor" @click="handleSelect('')"><el-image v-if="!$weidajs.isEmpty(logininfo.companyinfo.logo)" :src="$wdpicurl(logininfo.companyinfo.logo)" class="img"></el-image></div>
				<div class="wd-m-l-20 wd-m-r-40 quan" @click="handleSelect('')">返回商城首页</div>
				<div class="wd-row-grow wd-flex wd-row-left">
					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="menuclick" background-color="#e23435" text-color="#ffffff">
						<el-menu-item index="index" :route="{path:'/'}">首页</el-menu-item>
						<el-submenu index="memindex">
							<template slot="title">
								账户设置
							</template>
							<el-menu-item index="Myinfo">个人信息</el-menu-item>
							<el-menu-item index="Addrlist">收货地址</el-menu-item>
						</el-submenu>
						<el-menu-item index="Msglist" >消息</el-menu-item>
						<el-menu-item index="IntegralMall">积分商城</el-menu-item>
					</el-menu>
				</div>
				<div>
					<div class="btncart" @click="handleSelect('cart')">
						<i class="wd-icon wd-font-20">&#xe600;</i>
						<span class="wd-m-l-10">我的购物车</span>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="showtop === 1">
			<div class="wd-container wd-flex wd-row-between wd-m-t-20">
				<div class=" wd-flex wd-row-left">
					<div class="wd-cursor" @click="handleSelect('')"><el-image src="../img/logo.png" class="wd-img-50"></el-image></div>
					<div><span class="wd-m-l-20 wd-font-20 wd-theme-666">订单提交</span></div>
				</div>
				<div class="wd-flex wd-row-around progress">
					<div class="line a">
						<span class="num">1</span>
						<span class="memo">1.我的购物车</span>
					</div>
					<div class="line b">
						<span class="num">2</span>
						<span class="memo">2.填写核对订单信息</span>
					</div>
					<div class="line c">
						<span class="num">3</span>
						<span class="memo">3.成功提交订单</span>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="showtop === 2">
			<div class="wd-container wd-flex wd-row-between wd-m-t-20">
				<div class=" wd-flex wd-row-left">
					<div class="wd-cursor" @click="handleSelect('')"><el-image src="../img/logo.png" class="wd-img-50"></el-image></div>
					<div><span class="wd-m-l-20 wd-font-20 wd-theme-666">订单支付</span></div>
				</div>
				<div class="wd-flex wd-row-around progress">
					<div class="line a">
						<span class="num">1</span>
						<span class="memo">1.我的购物车</span>
					</div>
					<div class="line a">
						<span class="num">2</span>
						<span class="memo">2.填写核对订单信息</span>
					</div>
					<div class="line b">
						<span class="num">3</span>
						<span class="memo">3.成功提交订单</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { regionData, TextToCode } from 'element-china-area-data';
export default {
	name: 'Top3',
	computed: {
		...mapState(['logininfo'])
	},
	props: {
		showtop: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			options: regionData,
			selectedOptions: [],
			activeIndex: '1'
		};
	},
	methods: {
		handleChange(value) {
			localStorage.setItem("wd_addr",value);
			this.$store.commit("setaddrinfo",value);
		},
		menuclick(e) {
			console.log(e);
			this.handleSelect(e);
		},
		handleSelect(type) {
			if (type === 'login') {
				this.$router.push('/login');
			} else if (type === 'reg') {
				this.$router.push('/reg');
			} else if (type === 'search') {
				this.$router.push('/goodslist');
			} else if (type === 'cart') {
				this.$router.push('/member/cart');
			} else if (type === 'Orderlist') {
				this.$parent.setflag('Orderlist');
			} else if (type === 'Myinfo') {
				this.$parent.setflag('Myinfo');
			} else if (type === 'Favlist') {
				this.$parent.setflag('Favlist');
			} else if (type === 'Msglist') {
				this.$parent.setflag('Msglist');
			} else if (type === 'Historylist') {
				this.$parent.setflag('Historylist');
			} else if (type === 'Addrlist') {
				this.$parent.setflag('Addrlist');
			} else if (type === 'Help') {
				this.$router.push("/help");
			} else if (type === 'IntegralMall') {
				this.$router.push("/IntegralMall");
			} else if (type==='loginout'){
				this.$store.commit("loginout");
				this.$router.push('/');
			} else {
				this.$router.push('/');
			}
		},
		loadaddrdata() {
			this.addr_name = '';
			this.addr_mobile = '';
			this.addr_province = '';
			this.addr_other = '';
			this.addr_addr = '';
			this.addr_state = '0';
			
			var addrinfo=this.logininfo.addrinfo||"";
			console.log(addrinfo);
			if (this.$weidajs.isEmpty(addrinfo)){
				addrinfo=localStorage.getItem("wd_addr")||"";
				if (!this.$weidajs.isEmpty(addrinfo)){
					var arr = addrinfo.split(',');
					this.$store.commit("setaddrinfo",arr);
					return;
				}
			}else{
				this.$store.commit("setaddrinfo",addrinfo);
			}
			
			
			if (this.pid !== '') {
				let indata = {
					addrid: this.pid
				};
				this.$wd_request('defaultaddr', indata, true, '.addredit')
					.then(data => {
						console.log(data);
						var arr = [];
						var txt = data.value.province;
						arr = txt.split('-');
						var code = [];
						code[0] = TextToCode[arr[0]].code;
						code[1] = TextToCode[arr[0]][arr[1]].code;
						code[2] = TextToCode[arr[0]][arr[1]][arr[2]].code;
						localStorage.setItem("wd_addr",code);
						this.$store.commit("setaddrinfo",code);
					})
					.catch(() => {});
			}
		}
	},
	created() {
		this.loadaddrdata();
	}
};
</script>

<style lang="scss" scoped>
.top {
	.head {
		height: 40px;
		line-height: 40px;
		font-size: 12px;
		background-color: #f0f0f0;
		color: #666666;
		.top_r {
			.a {
				padding: 0 10px;
			}
			.b {
				width: 1px;
				height: 12px;
				padding: 0;
				margin: 10px 2px 0;
				background: #dedede;
				overflow: hidden;
			}
		}
	}
	.memtop {
		height: 60px;
		background-color: #e23435;
		color: #ffffff;
		.quan {
			border: 1px solid #ffffff;
			border-radius: 20px;
			padding: 2px 10px;
			font-size: 12px;
			&:hover {
				cursor: pointer;
				background-color: #ffffff;
				color: $wd-theme;
			}
		}
		.logo {
			width: 160px;
			height: 60px;
			// background-color: #FFFFFF;
			.img {
				width: 50px;
				height: 50px;
				margin: auto;
			}
		}
		.btncart {
			position: relative;
			z-index: 9;
			width: 180px;
			height: 44px;
			line-height: 44px;
			background: linear-gradient(0deg, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
			color: #fff;
			font-size: 14px;
			cursor: pointer;
			border-radius: 22px;
			text-align: center;
		}
	}
}
.progress {
	.line {
		position: relative;
		width: 160px;
		top: -5px;
		border-top: 5px solid #ccc;
		.num {
			position: absolute;
			left: 68px;
			top: -14px;
			color: #fff;
			font-weight: 700;
			width: 24px;
			height: 24px;
			line-height: 24px;
			background-color: #caecb6;
			border-radius: 50%;
			text-align: center;
		}
		.memo {
			position: absolute;
			top: 20px;
			color: #fff;
			font-weight: 700;
			height: 24px;
			line-height: 24px;

			width: 160px;
			text-align: center;
		}
		&.a {
			border-top-color: #caecb6;
			.num {
				background-color: #caecb6;
			}
			.memo {
				color: #caecb6;
			}
		}
		&.b {
			border-top-color: #7abd54;
			.num {
				background-color: #7abd54;
			}
			.memo {
				color: #7abd54;
			}
		}
		&.c {
			.num {
				background-color: #ccc;
			}
			.memo {
				color: #ccc;
			}
		}
	}
}
::v-deep .el-menu--horizontal > .el-menu-item.is-active {
	color: #ffffff;
}
</style>
